import { useState, useCallback } from "react";
import { inventoryFetchClient } from "./inventoryFetchClient";
import type { InventoryInspectionPdfOutput } from "./types";

export const useGenerateInventoryInspectionPdf = (
  options?: { onError?: (error: Error) => void }
) => {
  const [loading, setLoading] = useState(false);

  const generate = useCallback(
    async (
      propertyId: string,
      inspectionId: string
    ): Promise<InventoryInspectionPdfOutput> => {
      setLoading(true);
      try {
        const result = await inventoryFetchClient<InventoryInspectionPdfOutput>(
          `/properties/${propertyId}/inventory-inspections/${inspectionId}/pdf`,
          {
            method: "POST",
            operation: "generateInventoryInspectionPdf",
            onError: options?.onError,
          }
        );

        return result;
      } finally {
        setLoading(false);
      }
    },
    [options?.onError]
  );

  return { generate, loading };
};